/** Backend ENTITIES_SLICE_MAX_LIMIT is 100; larger limits are rejected. */
export const COMPLIANCE_SLICE_PAGE_SIZE = 100;

export const fetchAllSlicePages = async <T>(
  fetchPage: (offset: number, limit: number) => Promise<readonly T[]>,
  pageSize: number = COMPLIANCE_SLICE_PAGE_SIZE,
): Promise<T[]> => {
  const all: T[] = [];
  let offset = 0;
  let page: readonly T[];
  do {
    page = await fetchPage(offset, pageSize);
    all.push(...page);
    offset += pageSize;
  } while (page.length === pageSize);
  return all;
};
